$(function () {
  // set counters
  const trixEditors = document.querySelectorAll("trix-editor");

  trixEditors.forEach(function (editor) {
    const dataControllerAttribute = editor.parentElement.getAttribute('data-controller')
    if(dataControllerAttribute != 'rich-text-table')
    { 
      setCount(editor);

      editor.addEventListener("trix-change", function () {
        setCount(editor);
      });
    }
  });

  // skip tab for trix-toolbar
  const trixToolbars = document.querySelectorAll("trix-toolbar");
  trixToolbars.forEach(function (tB) {
    tB.addEventListener('keyup',(event) => {
      if (event.key == 'Tab') {
        tB.parentElement.querySelector('trix-editor').focus()
      }
    })
  })
})

function setCount(trixEditor) {
  // We need to get the length of the input field as the trix editor
  // values do not include the HMTL tags used for formatting
  const length = trixEditor.parentElement.querySelector('input').value.length;
  const maxLength = getLimit(trixEditor);
  const counterArea = trixEditor.nextSibling;

  if (maxLength && maxLength > 0) {
    counterArea.innerHTML = length + ' / ' + maxLength;

    if (length > maxLength) {
      counterArea.classList.add("text-danger");
      trixEditor.classList.add("text-danger");
      trixEditor.style.borderColor = "#cc0000";
    } else {
      counterArea.classList.remove("text-danger");
      trixEditor.classList.remove("text-danger");
      trixEditor.style.borderColor = "#bbb";
    }
  } else {
    counterArea.innerHTML = length;
  }
}

function getLimit(trixEditor) {
  const textInput = document.getElementById(trixEditor.getAttribute('input'));
  const maxLength = textInput.getAttribute("maxlength");

  if (maxLength && maxLength > 0) {
    return maxLength
  } else {
    return 0
  }
}
